(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cultured-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cultured-product-tabs')) {
    class CulturedProductTabs extends HTMLElement {
      connectedCallback() {
        this.tablist = this.querySelector('[data-cpt-tablist]');
        this.panels = Array.from(this.querySelectorAll('[data-cpt-panel]'));
        if (!this.tablist || !this.panels.length) return;

        this.ensureTabs();
        this.ensureTracks();
        this.tabs = Array.from(this.tablist.querySelectorAll('[data-cpt-tab]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activate(tab.dataset.cptTab));
        });
        this.tablist.addEventListener('keydown', (e) => this.onKey(e));

        const selected = this.tabs.find((t) => t.getAttribute('aria-selected') === 'true') || this.tabs[0];
        if (selected) this.activate(selected.dataset.cptTab, false, false);
        this.classList.add('is-ready');
        this.initArrows();

        this.onBlockSelect = (e) => {
          if (this.contains(e.target)) this.activate(e.detail.blockId, false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      /* ---------- Desktop left / right arrows ---------- */
      initArrows() {
        this.prevBtns = Array.from(this.querySelectorAll('[data-cpt-prev]'));
        this.nextBtns = Array.from(this.querySelectorAll('[data-cpt-next]'));
        if (!this.prevBtns.length && !this.nextBtns.length) return;

        this.prevBtns.forEach((b) => b.addEventListener('click', () => this.slide(-1)));
        this.nextBtns.forEach((b) => b.addEventListener('click', () => this.slide(1)));

        this.panels.forEach((panel) => {
          const grid = panel.querySelector('.cpt__grid');
          if (grid) grid.addEventListener('scroll', () => {
            if (!panel.hidden) this.updateArrows();
          }, { passive: true });
        });

        this.onResize = () => this.updateArrows();
        window.addEventListener('resize', this.onResize);
        /* Images change card height once loaded, so re-centre the side arrows */
        this.querySelectorAll('.cpt__grid img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', this.onResize, { once: true });
        });
        this.updateArrows();
      }

      activeGrid() {
        const panel = this.panels.find((p) => !p.hidden) || this.panels[0];
        return panel ? panel.querySelector('.cpt__grid') : null;
      }

      slide(dir) {
        const grid = this.activeGrid();
        if (!grid) return;
        const gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        grid.scrollBy({ left: dir * (grid.clientWidth + gap), behavior: reduce ? 'auto' : 'smooth' });
      }

      updateArrows() {
        if (!this.prevBtns) return;
        const grid = this.activeGrid();
        if (!grid) return;

        const max = grid.scrollWidth - grid.clientWidth;
        this.classList.toggle('cpt--no-overflow', max <= 2);
        this.prevBtns.forEach((b) => { b.disabled = grid.scrollLeft <= 2; });
        this.nextBtns.forEach((b) => { b.disabled = grid.scrollLeft >= max - 2; });

        /* Centre side arrows on the product image, not the whole card */
        const media = grid.querySelector('.cpc__media');
        const stage = this.querySelector('.cpt__stage');
        if (media && stage) {
          const top = media.getBoundingClientRect().top - stage.getBoundingClientRect().top + media.offsetHeight / 2;
          this.style.setProperty('--cpt-arrow-top', top + 'px');
        }
      }

      disconnectedCallback() {
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      /* Build one tab button per tab block (label + link come from the block) */
      ensureTabs() {
        this.tablist.innerHTML = '';
        this.panels.forEach((panel, i) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cpt__tab';
          btn.setAttribute('role', 'tab');
          btn.id = 'cpt-tab-' + panel.dataset.blockId;
          btn.setAttribute('aria-controls', panel.id);
          btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          btn.tabIndex = i === 0 ? 0 : -1;
          btn.dataset.cptTab = panel.dataset.blockId;
          btn.dataset.url = panel.dataset.url || '';
          btn.textContent = panel.dataset.label || 'Tab ' + (i + 1);
          this.tablist.appendChild(btn);
        });

        const wrap = this.querySelector('[data-cpt-tabs-wrap]');
        if (wrap) {
          const hide = this.hasAttribute('data-hide-single-tab') && this.panels.length < 2;
          wrap.classList.toggle('cpt__tabs-wrap--hidden', hide);
        }
      }

      /* Slider: count the cards so they fill row by row (keeps product order) */
      ensureTracks() {
        const rowsM = parseInt(this.dataset.rowsM, 10) || 1;
        const rowsD = parseInt(this.dataset.rowsD, 10) || 1;
        this.panels.forEach((panel) => {
          const grid = panel.querySelector('.cpt__grid');
          if (!grid) return;
          const count = grid.children.length;
          if (!count) return;
          grid.style.setProperty('--cpt-track-m', Math.max(1, Math.ceil(count / rowsM)));
          grid.style.setProperty('--cpt-track-d', Math.max(1, Math.ceil(count / rowsD)));
          grid.setAttribute('data-track-m', '');
          grid.setAttribute('data-track-d', '');
        });
      }

      activate(id, focus, scroll) {
        const tab = this.tabs.find((t) => t.dataset.cptTab === id);
        if (!tab) return;

        this.tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach((p) => { p.hidden = p.dataset.blockId !== id; });

        if (focus) tab.focus({ preventScroll: true });
        if (scroll !== false) {
          /* Scroll the tab bar only (never the page) so the active tab is visible */
          const wrap = this.tablist.parentElement;
          const left = tab.offsetLeft - (wrap.clientWidth - tab.offsetWidth) / 2;
          wrap.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }

        this.updateArrows();

        const url = tab.dataset.url;
        if (url) {
          this.querySelectorAll('[data-cpt-link]:not([data-cpt-fixed])').forEach((a) => { a.href = url; });
        }
      }

      onKey(e) {
        const i = this.tabs.indexOf(document.activeElement);
        if (i < 0) return;
        let next = null;
        if (e.key === 'ArrowRight') next = this.tabs[(i + 1) % this.tabs.length];
        if (e.key === 'ArrowLeft') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
        if (e.key === 'Home') next = this.tabs[0];
        if (e.key === 'End') next = this.tabs[this.tabs.length - 1];
        if (next) {
          e.preventDefault();
          this.activate(next.dataset.cptTab, true);
        }
      }
    }
    customElements.define('cultured-product-tabs', CulturedProductTabs);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deals-of-the-day"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__dealsWishlistInit) return;
    window.__dealsWishlistInit = true;

    const KEY = 'deals-wishlist';

    const read = () => {
      try {
        return JSON.parse(localStorage.getItem(KEY)) || [];
      } catch (e) {
        return [];
      }
    };

    const write = (list) => {
      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch (e) {}
    };

    const sync = (root = document) => {
      const list = read();
      root.querySelectorAll('[data-deal-wishlist]').forEach((btn) => {
        btn.setAttribute('aria-pressed', list.includes(btn.dataset.handle) ? 'true' : 'false');
      });
    };

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-deal-wishlist]');
      if (!btn) return;
      event.preventDefault();

      const handle = btn.dataset.handle;
      if (!handle) return;

      const list = read();
      const added = !list.includes(handle);
      write(added ? [...list, handle] : list.filter((h) => h !== handle));
      sync();

      // Hook point for a wishlist app / custom integration
      btn.dispatchEvent(
        new CustomEvent('deals:wishlist-toggle', {
          bubbles: true,
          detail: { handle, productId: Number(btn.dataset.productId), added },
        })
      );
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => sync());
    } else {
      sync();
    }

    document.addEventListener('shopify:section:load', (event) => sync(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
